export enum RouteState {
  PLANNED = "planned",
  ENDED = "ended",
  LIVE = "live",
  PLANNING = "planning",
}

export type RouteStateType = `${RouteState}`;
